module.exports = __webpack_public_path__ + "img/base2.4d256d7c.png";